import api from './api';

const UsersService = {
  // Get user profile by ID
  getUserProfile: (userId) => {
    return api.get(`/users/${userId}`);
  },

  getUsers: (params={}) => {
    return api.get(`/users`, { params});
  },

  getUserNotifications: (page) => {
    return api.get(`/notifications`, { params: { page } });
  },

  markNotificationAsRead: (notificationIds, mark_all) => {
    if (mark_all) {
        return api.post(`/notifications/mark-read`, { mark_all: true });
    }
    return api.post(`/notifications/mark-read`, { id: notificationIds });
  },

  // Get user posts
  getUserPosts: (userId, params = {}) => {
    return api.get(`/users/${userId}/posts`, { params });
  },

  // Follow a user
  followUnfollowUser: (userId, action) => {
    return api.post(`/users/${userId}/follow`, { action });
  },
  
  // Get user followers
  getUserFollowers: (userId, params = {}) => {
    return api.get(`/users/${userId}/followers`, { params });
  },
  
  // Get users that a user is following
  getUserFollowing: (userId, params = {}) => {
    return api.get(`/users/${userId}/following`, { params });
  },
  
  
  // Report a user
  reportUser: (userId, reason) => {
    return api.post(`/report`, {
      reported_user_id: userId,
      reason
    });
  }
};

export default UsersService;
